const API_BASE_URL =
    process.env.APP_BACKEND_URL || `${window.location.protocol}//${window.location.hostname}${window.location.port ? ":" + 8080 : ""}`;

export const BASE_URL = API_BASE_URL;
export const BASE_API = `${BASE_URL}/api/v1`;
export const LOGIN_API = `${BASE_API}/auth/login`;
export const GET_AUTH_INFO_API = `${BASE_API}/auth/authInfo`;
export const GET_AZURE_CREDENTIALS_API = `${BASE_API}/auth/azureCredentials`;
export const ACCOUNTS_API = `${BASE_API}/auth/accounts`;
export const LOGIN_AUTH0_API = `${BASE_API}/auth/login/auth0`;
export const USER_TOKEN_REFRESH_API = `${BASE_API}/auth/refreshToken`;
export const USER_AUTH_CREDENTIALS_API = `${BASE_API}/users/me/updateAuthCredentials`;
export const USER_NOTIFICATION_SETTINGS_API = `${BASE_API}/users/me/notificationSettings`;
export const USER_DATA_API = `${BASE_API}/users/me/data`;

// User notification APIs
export const ALL_NOTIFICATIONS_API = `${BASE_API}/notifications/{organizationId}/me/all`;
export const SINGLE_NOTIFICATION_API = `${BASE_API}/notifications/{organizationId}/me/{notificationId}`;
export const READ_ALL_NOTIFICATIONS_API = `${BASE_API}/notifications/{organizationId}/me/read-all`;

// Organization APIs
export const ORG_MEMBERS_API = `${BASE_API}/org/{organizationId}/members`;
export const ORG_ALL_INFO_API = `${BASE_API}/org/{organizationId}/allInfo`;
export const ORG_BASIC_INFO_API = `${BASE_API}/org/{organizationId}/basicInfo`;
export const ORG_CONTACT_SERVICES_API = `${BASE_API}/org/{organizationId}/contactServices`;
export const ORG_INVITATIONS_API = `${BASE_API}/org/{organizationId}/invitations`;
export const ORG_INVITATION_ITEM_API = `${BASE_API}/org/{organizationId}/invitations/{invitationId}`;
export const ORG_ROLES_API = `${BASE_API}/org/{organizationId}/roles`;
export const ORG_ROLE_ITEM_API = `${BASE_API}/org/{organizationId}/roles/{roleId}`;
export const ORG_SET_DEFAULT_ROLE_API = `${BASE_API}/org/{organizationId}/roles/{roleId}/setAsDefault`;
export const ORG_UPDATE_MEMBER_ROLE_API = `${BASE_API}/org/{organizationId}/members/updateMemberRole`;
export const ORG_MEMBER_ITEM_API = `${BASE_API}/org/{organizationId}/members/{memberId}`;
export const ORG_SERVICE_LEVELS_API = `${BASE_API}/org/{organizationId}/serviceLevels`;
export const ORG_SERVICE_LEVEL_ITEM_API = `${BASE_API}/org/{organizationId}/serviceLevels/{serviceLevelId}`;

// Dealer Group APIs
export const DGROUP_MEMBERS_API = `${BASE_API}/dealerGroup/{organizationId}/members`;
export const DGROUP_ALL_INFO_API = `${BASE_API}/dealerGroup/{organizationId}/allInfo`;
export const DGROUP_BASIC_INFO_API = `${BASE_API}/dealerGroup/{organizationId}/basicInfo`;
export const DGROUP_INVITATIONS_API = `${BASE_API}/dealerGroup/{organizationId}/invitations`;
export const DGROUP_INVITATION_ITEM_API = `${BASE_API}/dealerGroup/{organizationId}/invitations/{invitationId}`;
export const DGROUP_ROLES_API = `${BASE_API}/dealerGroup/{organizationId}/roles`;
export const DGROUP_ROLE_ITEM_API = `${BASE_API}/dealerGroup/{organizationId}/roles/{roleId}`;
export const DGROUP_SET_DEFAULT_ROLE_API = `${BASE_API}/dealerGroup/{organizationId}/roles/{roleId}/setAsDefault`;
export const DGROUP_UPDATE_MEMBER_ROLE_API = `${BASE_API}/dealerGroup/{organizationId}/members/updateMemberRole`;
export const DGROUP_MEMBER_ITEM_API = `${BASE_API}/dealerGroup/{organizationId}/members/{memberId}`;

// subscription
export const SUBSCRIPTION_CUSTOMER_INFO_API = `${BASE_API}/subscriptions/{organizationId}/customerInfo`;
export const SUBSCRIPTION_CURRENT_PLAN_API = `${BASE_API}/subscriptions/{organizationId}/currentPlan`;
export const SUBSCRIPTION_PAYMENT_METHODS_API = `${BASE_API}/subscriptions/{organizationId}/paymentMethods`;
export const SUBSCRIPTION_BILLING_HISTORY_API = `${BASE_API}/subscriptions/{organizationId}/billingHistory`;
export const SUBSCRIPTION_ALL_PLANS_API = `${BASE_API}/subscriptions/allPlans`;
